module.exports = __webpack_public_path__ + "img/template_4.f7608c57.png";